import React from 'react';
import PropTypes from 'prop-types';
import PartnerAccessFrequencySummary from './PartnerAccessFrequencySummary';
import { PartnerAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class PartnerAccessFrequencySummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerAccessFrequencyListService.load();
  }

  render() {
    const data = toJS(PartnerAccessFrequencyListService.getSummaryByType(this.props.type, this.props.typeId));

    return (
      <PartnerAccessFrequencySummary
        isLoading={
          PartnerAccessFrequencyListService.fetchCurrent.fetching ||
          PartnerAccessFrequencyListService.fetchPrevious.fetching
        }
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation')}
        formatter={PartnerAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerAccessFrequencySummaryContainer);
